import useVocabulary from './useVocabulary';
import { Vocabulary } from '../../types/catalog';

const selectAttributes = (vocabulary: Vocabulary) => vocabulary.attributes;

function useAttributes(enabled = true) {
  return useVocabulary(enabled, selectAttributes);
}

export default useAttributes;
